module.exports = __webpack_public_path__ + "static/media/Dingdong.bdba47b2.wav";